import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updatePartner,
  UpdatePartnerPayload,
} from '../../api/queries';

type UpdatePartnerParams = {
  partnerId: number;
  payload: UpdatePartnerPayload;
};

export const useUpdatePartnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, payload }: UpdatePartnerParams) =>
      updatePartner(partnerId, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['GET_PARTNERS'] });
      queryClient.invalidateQueries({ queryKey: ['GET_PARTNER_DETAIL', data.id] });
    },
  });
};
